import LocationResult from '@engbers/shop-backend/online-shop/models/LocationResult';

export const getStoreLocationLink = (store: LocationResult) => {
  return `https://www.google.de/maps?daddr=${store.street}+${store.streetNumber},+${store.zip}+${store.city},+${store.country}`;
};
